Rainbow.extend("http", [
  {
    "name": "entity.class",
    "pattern": /^(GET|POST|PUT|PATCH|DELETE)\s+/g
  },
  {
    "name": "entity.function",
    "pattern": /\/[^ ]*/g
  },
  {
    "matches": {
      1: "keyword",
      2: "blah"
    },
    "pattern": /([A-Za-z-]+:)(.*)/g
  }
]);